/*
 *
 * AppBar constants
 *
 */

export const DEFAULT_ACTION = "app/AppBar/DEFAULT_ACTION";
